import { defineMessages } from "react-intl";

import {
	resultMessages,
	validator
} from "lib/build/forms/ktx/transplantation-screening/imaging-procedures/abdominalCtMrAngiography";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	abdominalCtMrAngiography: {
		id: "ktx.abdominal_ct_mr_angiography.title",
		defaultMessage: "Has CT / MR / angiográfia"
	},
	result: {
		id: "ktx.abdominal_ct_mr_angiography.field.result",
		defaultMessage: "Eredmény"
	},
	comment: {
		id: "ktx.abdominal_ct_mr_angiography.field.comment",
		defaultMessage: "Megjegyzés"
	}
});

const fields: { [key: string]: FieldData } = {
	result: {
		type: "field",
		path: ["result"],
		label: messages.result,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: resultMessages } }
	},
	comment: {
		type: "field",
		path: ["comment"],
		label: messages.comment,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.result }] },
		{ columns: [{ width: 12, field: fields.comment }] }
	]
};

export const node: LeafNode = {
	id: "ktx_abdominalCtMrAngiography",
	value: {
		schemaId: "abdominalCtMrAngiography",
		title: messages.abdominalCtMrAngiography,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
